"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Stripe;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Stripe(_param) {
    var title = _param.title, props = _objectWithoutProperties(_param, [
        "title"
    ]);
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "44",
        height: "34",
        viewBox: "0 0 44 34",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": !!title
    }, props), title ? /*#__PURE__*/ _react.createElement("title", null, title) : null, /*#__PURE__*/ _react.createElement("path", {
        d: "M27.4791 15.1382C27.2797 15.1274 27.0803 15.1605 26.8956 15.2353C26.7109 15.31 26.5456 15.4245 26.4116 15.5702L26.4212 18.8436C26.5557 18.9851 26.7202 19.0956 26.9031 19.1674C27.0859 19.2391 27.2826 19.2703 27.4791 19.2587C28.3046 19.2587 28.8603 18.3759 28.8603 17.1938C28.8603 16.038 28.295 15.1382 27.4791 15.1382V15.1382ZM34.895 14.9707C34.3307 14.9707 33.7118 15.3848 33.7118 16.3825H36.0247C36.0247 15.3848 35.4421 14.9707 34.895 14.9707Z"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M40.1739 1H3.82609C2.81135 1 1.83817 1.39664 1.12063 2.10266C0.403105 2.80868 0 3.76624 0 4.76471V29.2353C0 30.2338 0.403105 31.1913 1.12063 31.8973C1.83817 32.6034 2.81135 33 3.82609 33H40.1739C41.1887 33 42.1618 32.6034 42.8794 31.8973C43.5969 31.1913 44 30.2338 44 29.2353V4.76471C44 3.76624 43.5969 2.80868 42.8794 2.10266C42.1618 1.39664 41.1887 1 40.1739 1ZM8.40496 21.2089C7.56291 21.2059 6.73024 21.0349 5.95722 20.7064V18.6056C6.7067 19.024 7.54455 19.2656 8.40496 19.3115C8.90713 19.3115 9.26583 19.1798 9.26583 18.7732C9.26583 17.7238 5.85774 18.1144 5.85774 15.6767C5.85774 14.1144 7.0687 13.1798 8.88896 13.1798C9.64991 13.1726 10.4051 13.3104 11.1129 13.5854V15.656C10.426 15.3008 9.66471 15.1075 8.88896 15.0913C8.4107 15.0913 8.12374 15.224 8.12374 15.5675C8.12374 16.5558 11.5404 16.088 11.549 18.7176C11.5529 20.2998 10.2702 21.2089 8.40496 21.2089V21.2089ZM15.884 15.2118H14.1804V18.344C14.1804 19.6494 15.597 19.2438 15.884 19.1289V20.9172C15.3914 21.1335 14.8542 21.2335 14.3153 21.2089C14.0091 21.2184 13.7042 21.1663 13.4192 21.0558C13.1342 20.9454 12.8751 20.779 12.6576 20.5667C12.4402 20.3544 12.269 20.1007 12.1545 19.8212C12.0401 19.5416 11.9847 19.242 11.9919 18.9407L12.0015 11.8734L14.189 11.4151L14.1804 13.3294H15.884V15.2118ZM20.5384 15.3614C20.2403 15.2625 19.9189 15.2533 19.6154 15.3352C19.3119 15.417 19.0401 15.586 18.8349 15.8207V21.0471H16.5928V13.3294H18.5297L18.6732 13.9826C18.8537 13.6725 19.1409 13.4363 19.483 13.3165C19.8251 13.1967 20.1995 13.2013 20.5384 13.3294V15.3614ZM23.3391 21.0471H21.0856V13.3294H23.3391V21.0471ZM23.3391 12.1793L21.0884 12.6565V10.8588L23.3391 10.3882V12.1793ZM28.0108 21.1967C27.4328 21.196 26.8725 21 26.4239 20.6414L26.4143 23.1384L24.1732 23.6089V13.3209H26.1456L26.2623 13.8678C26.736 13.4237 27.366 13.1771 28.0203 13.1798C29.589 13.1798 31.0688 14.5736 31.0812 17.1327C31.0745 19.9289 29.613 21.1995 28.0079 21.1995L28.0108 21.1967ZM38.126 18.0033H33.7384C33.8341 19.0442 34.6079 19.3445 35.4783 19.3445C36.2406 19.3583 36.9951 19.1917 37.6783 18.8588V20.6235C36.9137 21.023 36.0568 21.2204 35.1914 21.1967C33.0029 21.1967 31.4782 19.8555 31.4782 17.2005C31.4782 14.9586 32.7695 13.1769 34.9044 13.1769C37.0394 13.1769 38.1413 14.9586 38.1413 17.2174C38.1413 17.432 38.1231 17.8913 38.1231 18.0061L38.126 18.0033Z"
    }));
}

//# sourceMappingURL=Stripe.js.map